import { useEffect, useState } from "react";
import { LayerVisual, accentOf } from "@/components/layers";
import { VideoBody } from "@/components/player/MediaModal";

const animClass = (l) => (l.anim && l.anim !== "none" ? `anim-${l.anim}` : "");

const InlineVideo = ({ layer, active }) => {
  const [playing, setPlaying] = useState(false);
  useEffect(() => { setPlaying(active && layer.autoplay); }, [active, layer.autoplay]);
  if (playing) return <div className="h-full w-full overflow-hidden rounded"><VideoBody layer={{ ...layer, muted: true }} inline /></div>;
  return <button className="h-full w-full" onClick={() => setPlaying(true)} aria-label={layer.alt || `Play video ${layer.name}`} data-testid={`player-layer-play-${layer.id}`}><LayerVisual layer={layer} /></button>;
};

export const InteractiveLayer = ({ layer, active, onAction, playingAudio }) => {
  const style = { left: `${layer.x}%`, top: `${layer.y}%`, width: `${layer.w}%`, height: `${layer.h}%`, animationDelay: `${layer.animDelay || 0}s` };
  const label = layer.alt || layer.title || layer.name;
  const cls = `absolute ${active ? animClass(layer) : ""}`;

  if (layer.type === "video" && layer.mode === "inline") {
    return <div className={cls} style={style} data-testid={`player-layer-${layer.id}`}><InlineVideo layer={layer} active={active} /></div>;
  }
  if (layer.type === "text") {
    return <div className={cls} style={style} data-testid={`player-layer-${layer.id}`} aria-label={label}><LayerVisual layer={layer} /></div>;
  }
  if (layer.type === "image" && !layer.lightbox) {
    return <div className={cls} style={style} data-testid={`player-layer-${layer.id}`}><LayerVisual layer={layer} /></div>;
  }
  const isPlaying = playingAudio === layer.id;
  const hidden = layer.style === "invisible";
  const idle = hidden || layer.type === "link" ? "none" : layer.idle || "glow";
  const hover = layer.type === "link" ? "none" : layer.hover || "lift";
  return (
    <button
      className={`${cls} hs-btn hv-${hover} rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3D3DF0] ${isPlaying ? "ring-2 ring-[#5FA82E] rounded-full" : ""}`}
      style={{ ...style, "--hs": accentOf(layer) }}
      onClick={(e) => { e.stopPropagation(); onAction(layer); }}
      aria-label={label}
      title={label}
      data-testid={`player-layer-${layer.id}`}
    >
      <span className={`lv idle-${idle}`} style={{ animationDelay: `${(layer.id.charCodeAt(0) % 7) * 0.17}s` }}><LayerVisual layer={layer} /></span>
      {hover !== "none" && !hidden && label && <span className="hs-tip" aria-hidden>{label}</span>}
    </button>
  );
};
